export default __webpack_public_path__ + "static/media/nfo-card-banner-bse-1000-index-fund.fe3ac90a.webp";